var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const SimCard2 = (_a) => {
    var { color = '#FFB800', width = 16, height = 16 } = _a, props = __rest(_a, ["color", "width", "height"]);
    return (React.createElement("svg", { width: width, height: height, viewBox: `0 0 ${width} ${height}`, fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M10.6673 8.46V12.0533C10.6673 13.6133 9.62732 14.6467 8.07398 14.6467H3.92732C2.37398 14.6467 1.33398 13.6133 1.33398 12.0533V6.87333C1.33398 5.31333 2.37398 4.28 3.92732 4.28H6.48065C7.16732 4.28 7.82732 4.55333 8.31398 5.04L9.90732 6.62667C10.394 7.11333 10.6673 7.77333 10.6673 8.46Z", fill: color }),
        React.createElement("path", { d: "M14.6657 5.49999V9.09332C14.6657 10.6467 13.6257 11.6867 12.0724 11.6867H11.3324V8.45999C11.3324 7.59999 10.9857 6.75999 10.379 6.15332L8.7857 4.56666C8.17904 3.95999 7.33904 3.61332 6.47904 3.61332H5.3457C5.4657 2.22666 6.47237 1.31332 7.9257 1.31332H10.479C11.1657 1.31332 11.8257 1.58666 12.3124 2.07332L13.9057 3.66666C14.3924 4.15332 14.6657 4.81332 14.6657 5.49999Z", fill: color })));
};
export default SimCard2;
